<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>业务参数</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <swb-merchant-biz-param-list :groupCodeList="groupCodeList"></swb-merchant-biz-param-list>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbMerchantBizParamList from './MerchantBizParamList'
    Vue.regist(SwbMerchantBizParamList);

    export default{
        name: 'swb-biz-param-list-for-sale',
        path: '/biz/param/list/for/sale',
        avlScopes: 'retailer',
        desc: '销售管理-业务参数',
        helpArticleCode: 'servicer-biz-param-list-for-sale',
        data: function () {
            return {
                // ["出入库设置", "交易撮合设置"]
                groupCodeList: ["store.io", "trade.setting"]
            }
        },
        created: function () {
        },
        methods: {}
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/BizParamListForSale.vue